import React, { FunctionComponent, ReactNode } from 'react'
import { Badge, Text } from '@afterpaytouch/core'
import { Money } from '../../../'
import { isValidMoney } from '../../../Money/utils'
import { OrderSummaryLine } from '../OrderSummaryLine'
import { Money as MoneyValue } from '@afterpay/types'

interface OrderSummaryAmountProps {
  item: {
    label: ReactNode
    amount: MoneyValue
  }
  sublabel?: ReactNode
  subitem?: {
    label: ReactNode
    amount: MoneyValue
  }
  prefix?: '+' | '-' | ''
  badge?: boolean
  isLoading?: boolean
  testNameSpace?: string
  show?: boolean
  divider?: boolean
}

export const OrderSummaryAmount: FunctionComponent<OrderSummaryAmountProps> = ({
  item,
  subitem,
  sublabel,
  prefix = '',
  badge = false,
  isLoading = false,
  testNameSpace = '',
  show = true,
  divider = true,
}) => {
  const label = badge ? (
    <Badge icon='Afterpay' text={item.label} />
  ) : (
    <Text renderAs='span' bold size='M'>
      {item.label}
    </Text>
  )
  return show || isLoading ? (
    <>
      <OrderSummaryLine
        item={{
          label,
          sublabel,
          value: (
            <>
              {prefix}
              <Money value={item.amount} size='M' />
            </>
          ),
        }}
        isLoading={isLoading}
        testNameSpace={testNameSpace}
        divider={divider}
      />
      {/* @ts-ignore: OPERATION BLEED STOPPER */}
      {isValidMoney(subitem?.amount) && (
        <div className='relative mt-2 flex justify-end align-middle'>
          <Text testNameSpace={`order-summary-${testNameSpace}-sub-item`} renderAs='span' size='S'>
            {subitem?.label}
          </Text>
        </div>
      )}
    </>
  ) : null
}
